const TTL_MS = 60_000;

let cached: { n: number; at: number } | null = null;

export function readNotifCountCache(now = Date.now()): number | null {
  if (!cached) return null;
  if (now - cached.at > TTL_MS) return null;
  return cached.n;
}

export function writeNotifCountCache(n: number, now = Date.now()) {
  cached = { n, at: now };
}

export function clearNotifCountCache() {
  cached = null;
}
